import { css } from '@/styled-system/css';

// Figma widths with no matching size token.
const CONTENT_MAX_WIDTH = '720px';
const FOOTER_BUTTON_MIN_WIDTH = '164px';

// Panda only extracts responsive values written inline, so the device margins are repeated
// rather than shared through a const.
export const wizardContainerStyles = css.raw({
  width: '100%',
  maxWidth: 'breakpoint-xxl',
  marginInline: 'auto',
  paddingInline: { base: 'device.margin.mobile', md: 'device.margin.tablet', xl: 'device.margin.desktop' },
});

// Modal.Header sets paddingInline longhands, which a paddingInline shorthand loses to.
export const wizardHeaderStyles = css.raw({
  width: '100%',
  maxWidth: 'breakpoint-xxl',
  marginInline: 'auto',
  paddingInlineStart: { base: 'device.margin.mobile', md: 'device.margin.tablet', xl: 'device.margin.desktop' },
  paddingInlineEnd: { base: 'device.margin.mobile', md: 'device.margin.tablet', xl: 'device.margin.desktop' },
  paddingBlock: { base: 'layout.tight', md: 'layout.default' },
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 'layout.tight',
});

// Omitting Modal.Header reserves empty header space; rendering it hidden does not.
export const wizardHiddenHeaderStyles = css.raw({ display: 'none' });

export const wizardBodyStyles = css.raw({ paddingInline: 'none', paddingBlock: 'layout.default' });

export const wizardFooterStyles = css.raw({
  paddingInline: 'none',
  paddingBlock: { base: 'layout.tight', md: 'layout.default' },
});

export const wizardTitleStyles = css.raw({ minWidth: 'none' });

export const wizardExitButtonStyles = css.raw({ whiteSpace: 'nowrap', flexShrink: 0 });

export const wizardProgressStyles = css.raw({ marginBlockEnd: { base: 'layout.loose', md: 'layout.looser' } });

export const wizardContentGridStyles = css.raw({
  display: 'grid',
  gridTemplateColumns: { base: 'minmax(0, 1fr)', xl: `minmax(0, ${CONTENT_MAX_WIDTH})` },
});

// The calendar step is a week grid rather than a form, so it fills the container. A block wrapper
// also keeps TourCalendar's Layout.Content column placements inert instead of spawning columns.
export const wizardWideContentStyles = css.raw({ display: 'block' });

export const wizardFooterButtonStyles = css.raw({ minWidth: { lg: FOOTER_BUTTON_MIN_WIDTH } });
